import { ToWords } from "to-words/en-IN";
import type { ReceiptLineItem } from "@/components/common-receipt/CommonReceiptA5";
import {
  defaultA5ChromeProps,
  onlineOrPlainPaymentText,
} from "@/components/common-receipt/a5-print-defaults";

const toWords = new ToWords();

export type ProjectTakhmeenReceiptPrintRecord = {
  id?: string | number;
  receiptNo?: string | number;
  receiptDate?: string | Date;
  amount?: number;
  paymentMode?: string;
  paymentRef?: string | null;
  remarks?: string | null;
  createdBy?: string;
  admin?: { name?: string | null } | null;
  projectTakhmeen?: {
    itsNo?: string | null;
    memberName?: string | null;
    project?: { name?: string | null } | null;
  } | null;
};

export function projectTakhmeenReceiptPaymentText(data: ProjectTakhmeenReceiptPrintRecord): string {
  return onlineOrPlainPaymentText(data.paymentMode, data.paymentRef);
}

export function projectTakhmeenReceiptTowards(data: ProjectTakhmeenReceiptPrintRecord): string {
  const projectName = data.projectTakhmeen?.project?.name?.trim();
  return projectName ? `Project Takhmeen — ${projectName}` : "Project Takhmeen";
}

export function projectTakhmeenReceiptLines(
  data: ProjectTakhmeenReceiptPrintRecord
): ReceiptLineItem[] {
  const pledge = data.projectTakhmeen;
  const paymentText = projectTakhmeenReceiptPaymentText(data);
  return [
    {
      left: "Received from",
      right: `${pledge?.memberName ?? ""} ${
        pledge?.itsNo ? `(ITS - ${String(pledge.itsNo)})` : ""
      }`.trim(),
      bold: true,
    },
    {
      left: "The sum of Rupees",
      right: `${toWords.convert(Number(data.amount) || 0)} Only`,
      bold: true,
    },
    {
      left: "Received by / Towards",
      right: `${paymentText} towards ${projectTakhmeenReceiptTowards(data)}`,
    },
    ...(data.remarks ? [{ left: "Remarks", right: String(data.remarks) }] : []),
  ];
}

export function projectTakhmeenReceiptA5Props(data: ProjectTakhmeenReceiptPrintRecord) {
  return {
    ...defaultA5ChromeProps(),
    receiptHeaderText: "PROJECT TAKHMEEN RECEIPT",
    receiptNo: data.receiptNo != null ? String(data.receiptNo) : undefined,
    date: data.receiptDate,
    receiptLines: projectTakhmeenReceiptLines(data),
    amount: Number(data.amount),
    digitalSignatureValue: `${String(data.id)}|${String(data.admin?.name ?? data.createdBy ?? "")}`,
  };
}
